import {defineStore} from "pinia";

export const useDocumentStore = defineStore('document', {
        state: () => ({
            fichier: {},
            documents: [],
            section: {},
            sections: [],
            loading: false,
        }),
        actions: {
            setFichier(fichier) {
                this.fichier = fichier;
            },
            setDocuments(documents) {
                this.documents = documents
            },
            addDocument(sourceId, document) {
                this.documents.unshift(document)
                if (document.folder)
                    this.updateFolderFromSection(sourceId, document, this.sections, 'ADD');
            },
            updateDocument(sourceId, document) {
                let index = this.documents.findIndex(cl => cl.id === document.id)

                if(index !== -1)
                this.documents.splice(index, 1, document);

                if (document.folder)
                    this.updateFolderFromSection(sourceId, document, this.sections, 'UPDATE');
            },
            deleteDocument(sourceId, document) {
                let index = this.documents.findIndex(cl => cl.id === document.id)

                if(index !== -1)
                    this.documents.splice(index, 1)

                if (document.folder)
                    this.updateFolderFromSection(sourceId, document, this.sections, 'DELETE');
            },
            moveDocument(sourceId, destinationId, document, ) {

                this.deleteDocument(sourceId, document);
                if (document.folder)
                    this.updateFolderFromSection(destinationId, document, this.sections, 'ADD');
            },
            updateFolderFromSection(sourceId, item, items, action) {
                items.forEach((element) => {
                    if (sourceId === element.id) {
                        if (action === 'ADD') {
                            element.children.push(item);
                        } else if (action === 'UPDATE') {
                            element.children.splice(element.children.findIndex(cl => cl.id === item.id), 1, item);
                        } else if (action === 'DELETE') {
                            element.children.splice(element.children.findIndex(cl => cl.id === item.id), 1);
                        }
                    } else if (element.children.length > 0) {
                        this.updateFolderFromSection(sourceId, item, element.children, action);
                    }
                });
            },

            setSection(section) {
                this.section = section;
            },
            setSections(sections) {
                this.sections = sections
            },
            addSection(section) {
                this.sections.push(section)
            },
            updateSection(section) {
                let index = this.sections.findIndex(cl => cl.id === section.id)
                this.sections.splice(index, 1, section)
            },
            deleteSection(section) {
                let index = this.sections.findIndex(cl => cl.id === section.id)
                this.sections.splice(index, 1)
            },
        },
    })
;